
<div class="input-group-text col-12" style="background-color: transparent; border: none; padding: 0 1px 0 1px;">
<input class="form-control"
       [type]="showText ? 'text' : 'password'"
       (input)="onInput($any($event.target).value)"
       [notShowErrors]="true"
       [placeholder]="placeholder"
       maxlength="50"
       [(ngModel)]="value"
       [disabled]="disabled"
       [pattern]="pattern" 
       style="padding: 18px 12px;"
       />
<div class="input-group-addon"
style="padding: 0px 4px !important; margin-bottom: 10px;"
>
    <button type="button" class="btn"
            (click)="toggleShowText($event)">
        <i *ngIf="!showText"
           [title]="'SHARED.SHOW_PASSWORD' | translate"
           class="bi bi-eye-fill"
           style="color: #fff;">
        </i>
        <i *ngIf="showText"
           [title]="'SHARED.HIDE_PASSWORD' | translate"
           class="bi bi-eye-slash"
           style="color: #fff;">
        </i>
    </button>
</div>

</div>
